import Vue from 'vue';

const displayTagName = (value) => {
  if (value === 'TOTAL_PAYABLE') {
    return Vue.i18n.t('tag.totalPayable');
  }
  if (value === 'TOTAL_RECEIVABLE') {
    return Vue.i18n.t('tag.totalReceivable');
  }
  return value;
};

Vue.filter('tagName', displayTagName);


export const getTagOptions = () => {
  const result = JSON.parse(localStorage.getItem('tags'));
  return result ? result.map(t => ({
    text: displayTagName(t.name),
    value: t.id,
    hex_color: t.hex_color
  })) : [];
};

export const getTagsById = () => {
  const result = JSON.parse(localStorage.getItem('tags'));
  return result ? result.reduce((acc, t) => {
    acc[t.id] = t
    return acc
  }, {}) : {};
};


export const getTags = ids => JSON.parse(localStorage.getItem('tags')).filter(t => ids.indexOf(t.id) > -1);


export default {
  getTagOptions,
  getTagsById,
  getTags,
};



// WEBPACK FOOTER //
// ./src/utils/tag.js